module.exports = __webpack_public_path__ + "static/img/4.bae8d63b.png";